
import { useState } from 'react';

import { useSelector } from 'react-redux';

import { Link } from 'react-router';

import { Button, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';

import { FaSearch } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa6";

import { RootState } from '../../store';

import { ListItembuttonStyle, ListItemIconStyle, ListItemTextStyle, ListTypographyStyle, MenuItemStyle, TypographyAppBarStyle } from '../../styles/ListItemStyle';

export const ListItemConsultas = () => {

    const { roles } = useSelector( ( state: RootState ) => state.auth );

    const [anchorEl, anchorElOpen] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleOpen = ( e: React.MouseEvent<HTMLButtonElement, MouseEvent> ) => {
        anchorElOpen( e.currentTarget );
    };
    
    const handleClose = () => {
        anchorElOpen( null );
    };

    return (
        <>
        
            <ListItemText style={ ListItemTextStyle }>
        
                <Button color="inherit" style={ ListItembuttonStyle } onClick={ handleOpen }>

                    <FaSearch style={ ListItemIconStyle } />

                    <Typography sx={{ ...ListTypographyStyle, display: { xs: 'none', lg: 'flex' } }} >
                        Consultas
                    </Typography>     
                    
                    <FaChevronDown style={ ListItemIconStyle } />  

                </Button>

            </ListItemText>

            <Menu 
                elevation={ 2 } 
                anchorEl={ anchorEl } 
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                transformOrigin={{ vertical: "top", horizontal: "center" }} 
                keepMounted open={ open } 
                onClose={ handleClose }
                sx={{ width: 250 }}
            >

                {
                    roles?.ConsultaTramitesRecibidos
                    &&
                        <Link to="/consultas/tramites-recibidos/" style={{ textDecoration: "none" }}>
                            <MenuItem sx={{ ...MenuItemStyle, py: 2 }} onClick={ handleClose }> 
                                <ListItemIcon style={ ListItemIconStyle }> <FaSearch style={ ListItemIconStyle } /> </ListItemIcon>
                                <ListItemText style={TypographyAppBarStyle}>Trámites recibidos</ListItemText>
                            </MenuItem>   
                        </Link>
                }

            </Menu>
        
        </>        
    )
}